export enum DocumentType {
  AGENDA = 'agenda',
  ARTICLE = 'article',
  BRANCH_ACTIVITIES = 'branch_activities',
  CONTACT_PAGE = 'contact_page',
  CONTACT = 'contact',
  FINANCIAL_DEBT = 'financial_debt',
  FINANCIAL_KEY_FIGURES = 'financial_key_figures',
  FINANCIAL_PRESS_RELEASE = 'financial_press_release',
  FINANCIAL_PUBLICATION = 'financial_publication',
  FINANCIAL_RATING = 'financial_rating',
  FOOTER = 'footer',
  GOUVERNANCE = 'gouvernance',
  GROUP_HISTORY = 'group_history',
  HEADER = 'header',
  HOME = 'home',
  HUB_ACTUS = 'hub_actus',
  INNOVATION_BY_LA_POSTE = 'innovation_by_la_poste',
  LA_POSTE_EN_4 = 'la_poste_en_4',
  MEDIA_PRESS = 'media_presse',
  NEWSROOM = 'newsroom',
  OUR_BRANDS = 'our_brands',
  POSTMEN = 'postmen',
  PUBLIC_SERVICE_MISSIONS = 'public_service_missions',
  REWARDED_INNOVATION_PAGE = 'rewarded_innovation_page',
  REWARDED_INNOVATION = 'rewarded_innovation',
  SEARCH_PAGE = 'search_page',
}

export const singleDocumentTypes = [
  DocumentType.AGENDA,
  DocumentType.BRANCH_ACTIVITIES,
  DocumentType.CONTACT_PAGE,
  DocumentType.FINANCIAL_DEBT,
  DocumentType.FINANCIAL_KEY_FIGURES,
  DocumentType.FINANCIAL_PRESS_RELEASE,
  DocumentType.FINANCIAL_PUBLICATION,
  DocumentType.FINANCIAL_RATING,
  DocumentType.FOOTER,
  DocumentType.GOUVERNANCE,
  DocumentType.GROUP_HISTORY,
  DocumentType.HEADER,
  DocumentType.INNOVATION_BY_LA_POSTE,
  DocumentType.NEWSROOM,
  DocumentType.OUR_BRANDS,
  DocumentType.POSTMEN,
  DocumentType.PUBLIC_SERVICE_MISSIONS,
  DocumentType.REWARDED_INNOVATION_PAGE,
  DocumentType.SEARCH_PAGE,
];

export const multipleDocumentTypes = [
  DocumentType.HOME,
  DocumentType.ARTICLE,
  DocumentType.CONTACT,
  DocumentType.MEDIA_PRESS,
  DocumentType.REWARDED_INNOVATION,
];

export const knownDocumentTypes = [
  ...singleDocumentTypes,
  ...multipleDocumentTypes,
];

export type Meta = {
  title?: string;
  description?: string;
  image?: string;
  indexed: boolean;
};

export enum FrequenciesEnum {
  WEEKLY = 'weekly',
  ALWAYS = 'always',
  HOURLY = 'hourly',
  DAILY = 'daily',
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
  NEVER = 'never',
}

export type Document = {
  id: string;
  uid: string;
  type: DocumentType;
  lang: string;
  alternateLanguages: string[];
  createdAt: number;
  updatedAt: number;
};

export type PageType =
  | DocumentType.AGENDA
  | DocumentType.BRANCH_ACTIVITIES
  | DocumentType.CONTACT_PAGE
  | DocumentType.FINANCIAL_DEBT
  | DocumentType.FINANCIAL_KEY_FIGURES
  | DocumentType.FINANCIAL_PRESS_RELEASE
  | DocumentType.FINANCIAL_PUBLICATION
  | DocumentType.FINANCIAL_RATING
  | DocumentType.GOUVERNANCE
  | DocumentType.GROUP_HISTORY
  | DocumentType.HOME
  | DocumentType.HUB_ACTUS
  | DocumentType.INNOVATION_BY_LA_POSTE
  | DocumentType.LA_POSTE_EN_4
  | DocumentType.NEWSROOM
  | DocumentType.OUR_BRANDS
  | DocumentType.POSTMEN
  | DocumentType.PUBLIC_SERVICE_MISSIONS
  | DocumentType.REWARDED_INNOVATION_PAGE
  | DocumentType.MEDIA_PRESS
  | DocumentType.SEARCH_PAGE;

export type BreadcrumbParent = {
  linkType: string;
  type: string;
  id: string;
  lang: string;
  uid: string;
};

export type Page = Document & {
  type: PageType;
  meta: Meta;
  seoText?: string;
  sitemapPriority: number;
  sitemapChangeFrequency: FrequenciesEnum;
  breadcrumbParent?: BreadcrumbParent;
  breadcrumb: string;
  title: string;
  disableRgpbBanner: boolean;
};

export type Illustration = {
  src: string;
  width: number;
  height: number;
  thumbnail: Thumbnail;
};

export type Thumbnail = {
  square: Illustration;
  smallRect: Illustration;
  mediumRect: Illustration;
  largeRect: Illustration;
};

export type Filters = {
  category?: string;
  classification?: string;
  commonThematic?: string;
  expertise?: string;
  financialPublication?: string;
  mediaThematic?: string;
  mediaType?: string;
  menu?: string;
  publication?: string;
  region?: string;
  thematic?: string;
};

export type Article = Document & {
  illustration: Illustration;
  title: string;
  filters: Filters;
};
